<div
	class="modal fade"
	id="filtersModal"
	tabindex="-1"
	role="dialog"
	aria-labelledby="filtersModalLabel"
	aria-hidden="true"
>
	<div class="modal-dialog modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-body">
				<div class="mb-3 row">
					<label>Data utworzenia</label><br />
					<div class="form-inline">
						<input
							type="date"
							class="form-control"
							name="filters.date_from"
							[(ngModel)]="filters.date_from"
						/>
						<input type="date" class="form-control" name="filters.date_to" [(ngModel)]="filters.date_to" />
					</div>
				</div>
				<div class="mb-3 row">
					<label>Data aktualizacji</label><br />
					<div class="form-inline">
						<input
							type="date"
							class="form-control"
							name="filters.update_date_from"
							[(ngModel)]="filters.update_date_from"
						/>
						<input
							type="date"
							class="form-control"
							name="filters.update_date_to"
							[(ngModel)]="filters.update_date_to"
						/>
					</div>
				</div>
				<div class="mb-3 row">
					<label>Wyszukiwarka</label>
					<input
						type="text"
						class="form-control"
						id="filters.search"
						name="filters.search"
						[(ngModel)]="filters.search"
					/>
				</div>
				<div class="mb-3 row">
					<label>Status</label>
					<select class="form-control" [(ngModel)]="filters.status">
						<option value="">(wszystkie)</option>
						<option *ngFor="let item of statuses" [value]="item.id">
							{{ item.name }}
						</option>
					</select>
				</div>
				<div class="mb-3 row">
					<label>Rodzaj</label>
					<select class="form-control" [(ngModel)]="filters.type">
						<option value="">(wszystkie)</option>
						<option *ngFor="let item of types" [value]="item.id">
							{{ item.name }}
						</option>
					</select>
				</div>
				<div class="mb-3 row">
					<label>Opiekun</label>
					<ng-select
						id="owner"
						name="owner"
						[(ngModel)]="filters.owner"
						[items]="users"
						bindLabel="name"
						bindValue="id"
					></ng-select>
				</div>
			</div>
			<div class="modal-footer">
				<div class="row row-full">
					<div class="col-sm-4">
						<button type="button" class="btn btn-secondary" (click)="filtersClear()">Wyczyść filtry</button>
					</div>
					<div class="col-sm-8 text-end">
						<button type="button" class="btn btn-primary me-2" (click)="filtersSave()">Pokaż</button>
						<button type="button" class="btn btn-secondary" (click)="filtersClose()">Anuluj</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
